import React from 'react'

export const HydrationContext = React.createContext(null)
HydrationContext.displayName = 'HydrationContext'

export default HydrationContext
